{
	"submitTitle": "Select material",
	"summary": {
		"title": "Summary",
		"declarationTypeTitle": "Declaration type",
		"projectReferenceTitle": "Project reference"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Select the declaration type",
			"customerProject": {
				"title": "Customer project",
				"description": "The material was used for an external project. Now I need to provide a declaration detailing the carbon reductions for my customer."
			},
			"internalProjectOrProduct": {
				"title": "Internal project / product",
				"description": "The material was used for an internal project or product. I need to create a declaration to claim the carbon reductions for our own operations."
			}
		},
		"addProjectReferenceSection": {
			"title": "Add project reference",
			"subTitle": "You need to assign carbon reductions to a project reference that you want to create the declaration for.",
			"projectReferencePlaceholder": "Project reference"
		},
		"selectProjectSection": {
			"title": "Select a project",
			"createNewProjectPlaceholder": "Create new project"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Declaration type is required",
		"projectReferenceRequired": "Project reference is required",
		"fetchProjectsError": "Failed to fetch previous projects"
	}
}
